import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons text-2xl my-auto mx-1 text-gray-400 dark:text-dark-text" }, " search ", -1)
const _hoisted_2 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "px-1 border-2 flex border-primary-400 bg-white hover:bg-primary-50 dark:bg-dark-400 dark:border-dark-200",
    style: _normalizeStyle([{"transition":"background-color 1s"}, `width: ${_ctx.width}; height: ${_ctx.height}; border-radius: ${_ctx.radius}; margin-top: ${_ctx.margin_top}; margin-bottom: ${_ctx.margin_bottom}`])
  }, [
    _hoisted_1,
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
      class: "w-full focus:outline-none text-gray-800 dark:text-dark-text bg-transparent",
      name: "problemId",
      placeholder: _ctx.placeholder,
      type: "text",
      onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.enterForm(_ctx.value)), ["enter"]))
    }, null, 40, _hoisted_2), [
      [_vModelText, _ctx.value]
    ])
  ], 4))
}